import "./utils/consoleControl";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { registerServiceWorker } from "./serviceWorkerRegistration";
import { enforceCanonicalHost } from "./utils/canonicalHost";

/**
 * Chunk 로드 실패 시 강제 새로고침 (배포 후 캐시된 index.html로 인한 404 복구)
 * - "Unexpected token '<'" : JS 요청에 HTML(index.html)이 반환된 경우
 * - "Loading chunk" / "ChunkLoadError" : lazy 로드된 청크 404
 */
const isChunkLoadError = (message: string): boolean =>
  (message.includes("Unexpected token") && message.includes("<")) ||
  /Loading chunk \d+ failed/.test(message) ||
  /Loading CSS chunk \d+ failed/.test(message) ||
  message.includes("ChunkLoadError");

const RELOAD_COOLDOWN_MS = 5000;
let lastReloadAttempt = 0;

const handleChunkError = (): void => {
  const now = Date.now();
  if (now - lastReloadAttempt < RELOAD_COOLDOWN_MS) return;
  lastReloadAttempt = now;
  window.location.reload();
};

window.addEventListener("error", (event) => {
  if (event.message && isChunkLoadError(event.message)) {
    event.preventDefault();
    handleChunkError();
  }
});

window.addEventListener("unhandledrejection", (event) => {
  const msg = event.reason?.message ?? String(event.reason);
  if (isChunkLoadError(msg)) {
    event.preventDefault();
    handleChunkError();
  }
});

/**
 * 소셜 로그인 redirect가 성립하려면 앱 host가 Firebase authDomain과 같아야 한다.
 * 옮겨야 하는 접속이면 여기서 끝내고 화면을 그리지 않는다. 잘못된 host에서
 * 로그인을 시작하면 provider 왕복 뒤 handler가 missing initial state로 끝난다.
 */
if (!enforceCanonicalHost()) {
  // 옮기는 문서에서는 렌더링도, Service Worker 등록도 하지 않는다.
  // 잘못된 host에 SW를 설치해 두면 그 host가 계속 살아남는다.
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error("Failed to find the root element");
  }

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
  void registerServiceWorker();
}
